$(document).ready(function(){
    // Change order of elements in Login Form
    $('#loginform .login-username, #loginform .login-password, #learndash-reset-password-wrapper form p').each(function(){
        $(this).find('label').appendTo($(this));
        $(this).find('input').attr('placeholder', $(this).find('label').text());
    });
    
    function fieldToggleActive() {
        if($(this).val() || $(this).is(':focus')) {
            $(this).closest('.gfield').addClass('active');
        }
        else {
            $(this).closest('.gfield').removeClass('active');
        }
    }
    
    var floating_fields = 'input[type="text"], input[type="email"], input[type="password"], textarea';
    
    $('.gform_wrapper').on("focus blur", floating_fields, fieldToggleActive);

    $('.gform_wrapper').find(floating_fields).each(fieldToggleActive);
    
    
    // Trigger submit on button wrapper click
    $('.gform_wrapper, #loginform').on("click", ".button-wrapper, .login-submit", function(e) {
        if(!$(e.target).hasClass('button')){
            $(this).children('.button').click();
        }
    });
    
    if(typeof gform != 'undefined') {
        // Add loading class on button wrapper when form is submitted
        gform.addFilter( 'gform_spinner_target_elem', function( $targetElem, formId ) {
            $targetElem.parent('.button-wrapper').addClass('loading');
            return $targetElem;
        } );
    }
    
    $(document).on('gform_post_render', function(event, form_id, current_page){
        if ( jQuery('div.validation_error, div.gform_validation_errors').length > 0 ) {
            $('#gform_' + form_id).find(floating_fields).each(fieldToggleActive);
        }
    });
    
});
